// header.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { PersonName } from '../../person/models/person';

@Injectable({ providedIn: 'root' })
export class NavbarService {
  private _name = new BehaviorSubject<string>('');
  private _personName = new BehaviorSubject<string>('');

  /** Observable dat personName toont als gezet, anders de pagina titel */
  readonly name = combineLatest([this._name, this._personName]).pipe(
    map(([title, personName]) => personName || title)
  );

  /** Zet de pagina titel (wordt overschreven door personName indien gezet) */
  setName(name: string) {
    console.log("Setting title in navbar service: " + name);
    this._name.next(name);
  }

  /** Zet de persoonsnaam (heeft prioriteit boven pagina titel) */
  setPersonName(person: PersonName) {
    if (person) {
      const fullName = person.FirstName + " " + person.LastName;
      console.log("Setting person name in navbar service: " + fullName);
      this._personName.next(fullName);
    }
  }

  /** Reset de persoonsnaam (bijv. bij uitloggen of persoon wissel) */
  clearPersonName() {
    this._personName.next('');
  }
}
